<carousel>
  <div *ngFor="let banner of banners" #cell class="carousel-cell">
    <banner-card [banner]="banner"></banner-card>
  </div>
</carousel>
